import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { showNotification } from "@mantine/notifications";
import {
  ActionIcon,
  Badge,
  Button,
  Pagination,
  Select,
  Skeleton,
  Table,
  Text,
  TextInput,
  Anchor,
  Modal,
  Tooltip,
} from "@mantine/core";
import { BeatLoader } from "react-spinners";
import { DatePicker } from "@mantine/dates";
import {
  Eye,
  History,
  Search,
  Plus,
  SortAscending,
  SortDescending,
} from "tabler-icons-react";
import { formatISO } from "date-fns";
import { useDebouncedValue } from "@mantine/hooks";
import {
  deleteAgreement,
  deleteAgreementBulk,
  getRelatedAgreement,
} from "../../utilities/apis/agreements";
import {
  getValueForInput,
  loadingStates,
  csvDownload,
  formatDate,
  formatIndianNumber,
} from "../../utilities/utilities";
import { apiWrapWithErrorWithData } from "../../utilities/apiHelpers";
import {
  getAgreementsList,
  getAgreementTypesApi,
  getAgreementsCsvDownload,
} from "../../utilities/apis/agreements";
import UserAvatarView from "../../components/UserAvatarView";
import DashboardNotifications from "../DashboardNotifications";
import {
  agreementStatusColors,
  getStatusColor,
  getStatusText,
} from "../../utilities/enums";
import AgreementAnalytics from "../../components/AgreementAnalytics/AgreementAnalytics";
import colors, { themeColor } from "../../utilities/design";
import AgreementGraph from "./AgreementGraph";
import Styles from "./AgreementsListingPage.module.css";
import { INDIA_STATES_UNIONS } from "./AgreementForm2";
import { selectUserData } from "../../redux/selectors";
import { useSelector } from "react-redux";
import AgreementListModal from "./AgreementListModal";
import AgreementAuditLogModal from "./AgreementAuditLogModal";
import RelatedAgreementModal from "./agreementRelatedModal";
import { getPartiesList, getPartyNames } from "../../utilities/apis/parties";
import { getBussinessUnit } from "../../utilities/apis/serviceProvider";
import {
  IconArrowDownBar,
  IconArrowUpBar,
  IconEdit,
} from "@tabler/icons-react";
import { IconTrash } from "@tabler/icons-react";
import UniversalTable from "../../components/Common/UniversalTable";
import TablePagination from "../../components/Common/TablePagination";

const statusOptions = [
  {
    label: "INITIATED",
    value: "CREATED",
  },
  {
    label: "UNDER REVIEW",
    value: "REVIEW",
  },
  {
    label: "PENDING APPROVAL",
    value: "APPROVAL",
  },
];

const estampOption = [
  {
    label: "Yes",
    value: "Yes",
  },
  {
    label: "No",
    value: "No",
  },
];

const AgreementsListPage = () => {
  const [businessunitList, setbusinessunitList] = useState([]);
  const [pageSize, setPageSize] = useState(10);

  useEffect(() => {
    const fetchBusinessUnits = async () => {
      try {
        const { data } = await getBussinessUnit();
        if (data) {
          setbusinessunitList(data.businessunitList || []);
        } else {
          console.error("Invalid business unit response format:", response);
        }
      } catch (error) {
        console.error("Error fetching business units:", error);
      }
    };

    fetchBusinessUnits();
  }, []);

  const [open, setOpen] = useState(false);
  const [deleteOpen, setDeleteOpen] = useState(false);
  const currentUser = useSelector(selectUserData) || {};
  const [listing, setListing] = useState({
    list: null,
    agreementsCount: null,
    loaded: false,
    sortBy: "createdAt",
    sortDirection: "desc",
    searchString: "",
    statusType: "",
    estamp: null,
    agreementType: null,
    location: null,
    startDate: null,
    endDate: null,
    partyName: "",
    businessunit: "",
    jobOrder: "",
  });
  const handleKeyChange = (val) => {
    setListing({ ...listing, sortBy: val });
  };
  const toggleOrder = () => {
    setListing({
      ...listing,
      sortDirection: listing.sortDirection === "asc" ? "desc" : "asc",
    });
  };
  const [agreementTypeOptions, setAgreementTypeOptions] = useState([]);
  const [parties, setParties] = useState(["secondparty"]);
  const [uiConfigs, setUiConfigs] = useState({
    loading: loadingStates.NO_ACTIVE_REQUEST,
    page: 1,
  });
  const [debouncedSearchInput] = useDebouncedValue(listing.searchString, 500);
  const [agreementPayload, setAgreementPayload] = useState({});
  const [exportButtonLoading, setExportButtonLoading] = useState(false);

  const [selectedIds, setSelectedIds] = useState([]);
  const [deleteLoading, setDeleteLoading] = useState(false);

  const handleCheckboxChange = (id, isChecked) => {
    setSelectedIds((prevSelectedIds) => {
      if (isChecked) {
        return [...prevSelectedIds, id];
      } else {
        return prevSelectedIds.filter((selectedId) => selectedId !== id);
      }
    });
  };
  const [transformedData, settransformedData] = useState([]);
  useEffect(() => {
    if (businessunitList.length > 0) {
      settransformedData(
        businessunitList.map((unit) => ({
          value: unit.id + "",
          label: unit.name,
        })),
      );
    }
  }, [businessunitList]);

  const deleteHandler = async () => {
    // setDeleteLoading(true);
    const response = await apiWrapWithErrorWithData(
      deleteAgreement({ agreementId: deleteId }),
    );
    if (response?.success) {
      showNotification({
        color: "green",
        title: "Agreements",
        message: "Agreement deleted successfully.",
      });
      setDeleteOpen(false);
      window.location.reload();
    } else {
      showNotification({
        color: "red",
        title: "Agreements",
        message: "Unable to delete agreement",
      });
    }
    // setDeleteLoading(false);
  };

  const fetchAgreementsList = async ({ page }) => {
    let filterOptions = {};
    if (listing.startDate && listing.endDate) {
      filterOptions["createdAt"] = {
        gte: formatISO(listing.startDate),
        lte: formatISO(listing.endDate),
      };
    } else if (listing.startDate || listing.endDate) {
      showNotification({
        title: "Agreement notification",
        message: "please select start and end date",
        color: "red",
      });
      return;
    }
    setUiConfigs({
      ...uiConfigs,
      loading: loadingStates.LOADING,
    });
    const payload = {
      page: page ? page : uiConfigs.page,
      sortByOptions: {
        [listing.sortBy]: listing.sortDirection,
      },
      pageSize: pageSize,
    };
    if (
      listing.agreementType &&
      listing.statusType &&
      listing.estamp &&
      listing.businessunit
    ) {
      filterOptions = {
        ...filterOptions,
        typeOfAgreement: {
          equals: listing.agreementType,
        },
        status: {
          equals: listing.statusType,
        },
        agreementType: {
          equals: listing.estamp === "Yes" ? "eStamp" : "normal",
        },
        mapBusinessunit: {
          equals: listing.businessunit,
        },
      };
    } else if (
      listing.agreementType ||
      listing.statusType ||
      listing.estamp ||
      listing.businessunit
    ) {
      if (listing.agreementType) {
        filterOptions["typeOfAgreement"] = {
          equals: listing.agreementType,
        };
      }
      if (listing.statusType) {
        filterOptions["status"] = {
          equals: listing.statusType,
        };
      }
      if (listing.estamp) {
        filterOptions["agreementType"] = {
          equals: listing.estamp === "Yes" ? "eStamp" : "normal",
        };
      }
      if (listing.businessunit) {
        filterOptions["mapBusinessunit"] = {
          equals: listing.businessunit,
        };
      }
    }
    if (listing.location) {
      filterOptions["location"] = listing.location;
    }
    if (listing.partyName.length > 0) {
      filterOptions["OR"] = [
        { secondParty: { path: "$.name", string_contains: listing.partyName } },
        {
          secondParty: {
            path: "$.indi_name",
            string_contains: listing.partyName,
          },
        },
        {
          secondParty: {
            path: "$.brandName",
            string_contains: listing.partyName,
          },
        },
      ];
    }
    if (listing.jobOrder.length > 0) {
      filterOptions["jobOrder"] = { contains: listing.jobOrder };
    }
    payload["filterOptions"] = filterOptions;

    setAgreementPayload(payload);
    const response = await apiWrapWithErrorWithData(
      getAgreementsList({ ...payload }),
    );
    if (response?.success && response?.agreements) {
      setListing({
        ...listing,
        list: response?.agreements,
        agreementsCount: response.agreementsCount,
        loaded: true,
      });
    }
    setUiConfigs({
      ...uiConfigs,
      loading: loadingStates.NO_ACTIVE_REQUEST,
    });
  };
  const [data, setData] = useState(null);
  useEffect(() => {
    setData(listing.list);
  }, [listing.list]);
  // const data = listing?.list;

  useEffect(() => {
    getAgreementTypes();
    const getPartyName = async () => {
      const response = await apiWrapWithErrorWithData(getPartyNames());
      if (response.success) {
        setParties(response.parties);
      }
    };
    getPartyName();
  }, []);

  useEffect(() => {
    if (listing.agreementType || listing.statusType || listing.estamp) {
      fetchAgreementsList({ page: 1 });
      setUiConfigs((prevState) => ({
        ...prevState,
        page: 1,
      }));
    } else if (listing.estamp) {
      fetchAgreementsList({ page: 1 });
      setUiConfigs((prevState) => ({
        ...prevState,
        page: 1,
      }));
    } else if (listing.startDate && listing.endDate) {
      fetchAgreementsList({ page: 1 });
      setUiConfigs((prevState) => ({
        ...prevState,
        page: 1,
      }));
    } else {
      if (listing.startDate === null && listing.endDate === null) {
        fetchAgreementsList({});
      }
    }
  }, [listing.sortBy, listing.sortDirection]);

  useEffect(() => {
    fetchAgreementsList({});
  }, [uiConfigs.page, pageSize]);

  const navigate = useNavigate();
  const onViewClick = (agreementId) => {
    const url = `/app/agreements_manager/agreements/details/${agreementId}`;
    window.open(url, "_blank"); // '_blank' specifically tells the browser to open in a new tab/window
  };

  const getAgreementTypes = async () => {
    const resp = await apiWrapWithErrorWithData(getAgreementTypesApi());
    if (resp?.success && resp?.typesOfAgreement) {
      const uniqueValues = Array.from(new Set([...resp.typesOfAgreement]));
      const temp = uniqueValues.map((item) => ({ label: item, value: item }));
      setAgreementTypeOptions([...agreementTypeOptions, ...temp]);
    }
  };
  const handleCsvDownload = async () => {
    try {
      setExportButtonLoading(true);
      const response = await apiWrapWithErrorWithData(
        getAgreementsCsvDownload({ ...agreementPayload }),
      );
      if (response.success) {
        if (response?.agreements.length > 0) {
          const columnHeaders = Object.keys(response.agreements[0]);
          csvDownload({
            data: response.agreements,
            headers: columnHeaders,
            name: "my agreements",
          });
        } else {
          showNotification({
            title: "Agreement csv download",
            message: "No agreement available",
            color: "red",
          });
        }
      }
      setExportButtonLoading(false);
    } catch (error) {
      setExportButtonLoading(false);
      showNotification({
        title: "Agreement csv download",
        message: "Could not load agreement csv",
        color: "red",
      });
    }
  };

  const clearHandler = async () => {
    try {
      setUiConfigs({
        ...uiConfigs,
        page: 1,
        loading: loadingStates.LOADING,
      });

      const payload = {
        page: 1,
        sortByOptions: {
          [listing.sortBy]: listing.sortDirection,
        },
        filterOptions: {},
        pageSize: pageSize,
      };

      setAgreementPayload(payload);
      const response = await apiWrapWithErrorWithData(
        getAgreementsList({ ...payload }),
      );

      if (response?.success && response?.agreements) {
        setListing({
          ...listing,
          searchString: "",
          agreementType: "",
          statusType: null,
          estamp: "",
          location: null,
          startDate: null,
          endDate: null,
          list: response?.agreements,
          agreementsCount: response.agreementsCount,
          loaded: true,
          estamp: null,
          partyName: "",
          businessunit: "",
          jobOrder: "",
        });
      }

      setUiConfigs({
        ...uiConfigs,
        loading: loadingStates.NO_ACTIVE_REQUEST,
      });
    } catch (error) {
      console.log("Agreement list fetching error: ", error);
    }
  };
  const [showModal, setShowModal] = useState(false);
  const [agreementId, setAgreementId] = useState(null);
  const [deleteId, setDeleteId] = useState(0);
  const [showModalRelated, setShowModalRelated] = useState(false);
  const [relatedAgreementId, setRelatedAgreementId] = useState(null);
  const [dropDownNames, setDropDownNames] = useState([]);

  const handleSearchClick = (id) => {
    // Set the showModal state to true when the button is clicked
    setShowModal(true);
    // Pass the row id to the AgreementAuditLogModal component
    setAgreementId(id);
  };
  const partiesApi = async (name) => {
    const { data: res } = await apiWrapWithErrorWithData(
      getPartiesList({
        name,
        parent: "agreement",
      }),
    );
    // console.log("response for parties: ", res);
    // setParties(res);
    const names = Array.isArray(res) ? res.map(({ name: val }) => val) : [];
    setDropDownNames(names);
  };
  useEffect(() => {
    partiesApi();
  }, []);

  const handlePlusClick = async ({ id }) => {
    setShowModalRelated(true);
    setRelatedAgreementId(id);
  };

  const handleCloseModal = () => {
    // Set the showModal state to false when the modal is closed
    setShowModal(false);
  };
  const handleCloseRelatedAgreementModal = () => {
    setShowModalRelated(false);
  };
  console.log("deleteOpen: ", deleteOpen);
  console.log("deleteid: ", deleteId);
  // console.log("data: ", data);
  // console.log(listing);

  // const subTextStyle = { fontSize: '10px', fontWeight: 400, opacity: 0.7, lineHeight: 1.2 };

  // const tableHeaders = [
  //   {
  //     // Combined CIN/JO
  //     label: (
  //       <div>
  //         <div>CIN</div>
  //         <div style={subTextStyle}>JOB ORDER</div>
  //       </div>
  //     ),
  //     render: (row) => (
  //       <div className="flex flex-col" style={{ minWidth: "80px" }}>
  //         <Text size="xs" weight={600} color="#43A3B3">{`#${row.id}`}</Text>
  //         <Text size="10px" color="dimmed" style={{ whiteSpace: "nowrap" }}>
  //           {row.jobOrder || "NO JO"}
  //         </Text>
  //       </div>
  //     ),
  //   },
  //   {
  //     // Combined Cat/BU
  //     label: (
  //       <div>
  //         <div>Category</div>
  //         <div style={subTextStyle}>BU</div>
  //       </div>
  //     ),
  //     render: (row) => {
  //       const data = row.agreementData?.json;
  //       return (
  //         <div className="flex flex-col">
  //           <Text size="xs" weight={500}>
  //             {data?.typeOfAgreement || "--"}
  //           </Text>
  //           <Text size="10px" color="dimmed">
  //             {data?.location || "--"}
  //           </Text>
  //         </div>
  //       );
  //     },
  //   },
  //   {
  //     label: "ACV (INR)",
  //     render: (row) => (
  //       <Text size="xs">{formatIndianNumber(row.agreementValue)}</Text>
  //     ),
  //     style: { whiteSpace: "nowrap" },
  //   },
  //   {
  //     label: (
  //       <div>
  //         <div>Second Party</div>
  //         <div style={subTextStyle}>Brand Name</div>
  //       </div>
  //     ),
  //     render: (row) => {
  //       const { brandName, secondParty } = row.agreementData?.json || {};
  //       const partyName = secondParty?.name;
  //       return (
  //         <div className="flex flex-col" style={{ maxWidth: "180px" }}>
  //           <Text size="xs" weight={500} truncate>
  //             {partyName || brandName || "--"}
  //           </Text>
  //           {partyName && brandName && (
  //             <Text size="10px" color="dimmed" truncate>
  //               {brandName}
  //             </Text>
  //           )}
  //         </div>
  //       );
  //     },
  //   },
  //   // {
  //   //   label: (
  //   //     <div>
  //   //       <div>Second Party</div>
  //   //       <div style={subTextStyle}>Brand Name</div>
  //   //     </div>
  //   //   ),
  //   //   render: (row) => {
  //   //     const { brandName, secondParty } = row.agreementData?.json || {};
  //   //     const partyName = secondParty?.name;
  //   //     const displayName = partyName || brandName || "--";

  //   //     return (
  //   //       <div className="flex flex-col" style={{ maxWidth: "180px" }}>
  //   //         {/* Main Name with Tooltip */}
  //   //         <Tooltip
  //   //           label={displayName}
  //   //           disabled={displayName === "--"}
  //   //           withArrow
  //   //         >
  //   //           <Text size="xs" weight={500} truncate style={{ cursor: "default" }}>
  //   //             {displayName}
  //   //           </Text>
  //   //         </Tooltip>

  //   //         {/* Brand Name Subtext with Tooltip */}
  //   //         {partyName && brandName && (
  //   //           <Tooltip label={brandName} withArrow>
  //   //             <Text
  //   //               size="10px"
  //   //               color="dimmed"
  //   //               truncate
  //   //               style={{ cursor: "default" }}
  //   //             >
  //   //               {brandName}
  //   //             </Text>
  //   //           </Tooltip>
  //   //         )}
  //   //       </div>
  //   //     );
  //   //   },
  //   // },
  //   {
  //     label: "Status",
  //     render: (row) => (
  //       <Badge size="xs" color={row.status}>
  //         {getStatusText(row.status)}
  //       </Badge>
  //     ),
  //   },
  //   {
  //     label: "Contract Date", // Shortened from Initiation Date
  //     render: (row) => <Text size="xs">{formatDate(row.createdAt)}</Text>,
  //   },
  //   // { label: "Ageing", render: (row) => <Text size="xs">{row.ageing || "--"}</Text> }, // Shortened label
  //   {
  //     label: "Pending With", // Shortened from Pending With
  //     render: (row) => (
  //       <Text size="xs" truncate>
  //         {row.pendingWith || "--"}
  //       </Text>
  //     ),
  //   },
  //   // {
  //   //   label: "Editor", // Shortened from Pending With
  //   //   render: (row) => <Text size="xs" truncate>{row.editorName || "--"}</Text>
  //   // },
  //   {
  //     label: "Actions",
  //     align: "right",
  //     render: (row) => (
  //       <div className="flex flex-row justify-end items-center gap-2">
  //         {/* Plus Icon logic */}
  //         {row.relationshipWith ? (
  //           <ActionIcon size="sm" onClick={() => handlePlusClick({ id: row.id })}>
  //             <Plus color="#1b6f8d" size={16} />
  //           </ActionIcon>
  //         ) : (
  //           <div className="w-6" /> // Placeholder to keep icons aligned
  //         )}

  //         {/* View Icon */}
  //         <ActionIcon size="sm" onClick={() => onViewClick(row.id)}>
  //           <Eye color="#1b6f8d" size={16} />
  //         </ActionIcon>

  //         {/* History Icon */}
  //         <ActionIcon size="sm" onClick={() => handleSearchClick(row.id)}>
  //           <History color="#1b6f8d" size={16} />
  //         </ActionIcon>

  //         {/* Edit Icon - for ID 3 and 4 */}
  //         {(currentUser.loginAs.id === 3 || currentUser.loginAs.id === 4) && (
  //           <ActionIcon
  //             size="sm"
  //             onClick={() => {
  //               navigate("/app/agreements_manager/agreements/edit", {
  //                 state: { agreementId: row.id },
  //               });
  //             }}
  //           >
  //             <IconEdit color="#1b6f8d" size={16} />
  //           </ActionIcon>
  //         )}

  //         {/* Delete Icon - for ID 4 only */}
  //         {currentUser.loginAs.id === 4 && (
  //           <ActionIcon
  //             size="sm"
  //             onClick={() => {
  //               setDeleteOpen(true);
  //               setDeleteId(parseInt(row.id));
  //             }}
  //           >
  //             <IconTrash size={16} color="#1b6f8d" />
  //           </ActionIcon>
  //         )}
  //       </div>
  //     ),
  //   },
  // ];
  const subTextStyle = {
    fontSize: "10px",
    color: "#94a3b8", // Slate 400
    fontWeight: 400,
    lineHeight: "1.2",
    marginTop: "2px",
  };

  const tableHeaders = [
    {
      label: (
        <div className="flex flex-col">
          <span className="leading-tight">CIN</span>
          <span style={subTextStyle}>JOB ORDER</span>
        </div>
      ),
      render: (row) => (
        <div className="flex flex-col py-1" style={{ minWidth: "90px" }}>
          <Text size="xs" weight={600} color="#1b6f8d">{`#${row.id}`}</Text>
          <Text size="10px" color="dimmed" className="whitespace-nowrap">
            {row.jobOrder || "NO JO"}
          </Text>
        </div>
      ),
    },
    {
      label: (
        <div className="flex flex-col">
          <span className="leading-tight">Category</span>
          <span style={subTextStyle}>BU</span>
        </div>
      ),
      render: (row) => {
        const data = row.agreementData?.json;
        return (
          <div className="flex flex-col py-1">
            <Text size="xs" weight={500} className="text-slate-700">
              {data?.typeOfAgreement || "--"}
            </Text>
            <Text size="10px" color="dimmed">
              {data?.location || "--"}
            </Text>
          </div>
        );
      },
    },
    {
      label: "ACV (INR)",
      render: (row) => (
        <Text size="xs" weight={600} className="tabular-nums">
          {formatIndianNumber(row.agreementValue)}
        </Text>
      ),
    },
    {
      label: (
        <div className="flex flex-col">
          <span className="leading-tight">Second Party</span>
          <span style={subTextStyle}>Brand Name</span>
        </div>
      ),
      render: (row) => {
        const { brandName, secondParty } = row.agreementData?.json || {};
        const partyName = secondParty?.name;
        const displayName = partyName || brandName || "--";
        return (
          <div className="flex flex-col py-1" style={{ maxWidth: "200px" }}>
            <Text size="xs" weight={500} truncate title={displayName}>
              {displayName}
            </Text>
            {partyName && brandName && (
              <Text size="10px" color="dimmed" truncate title={brandName}>
                {brandName}
              </Text>
            )}
          </div>
        );
      },
    },
    {
      label: "Status",
      render: (row) => (
        <Badge
          // variant="light"
          size="xs"
          className="capitalize"
          color={row.status}
        >
          {getStatusText(row.status)}
        </Badge>
      ),
    },
    {
      label: "Contract Date",
      render: (row) => (
        <Text size="xs" className="text-slate-500">
          {formatDate(row.createdAt)}
        </Text>
      ),
    },
    {
      label: "Pending With",
      render: (row) => (
        <Text size="xs" truncate className="max-w-[120px] text-slate-600">
          {row.pendingWith || "--"}
        </Text>
      ),
    },
    {
      label: "Actions",
      align: "right",
      render: (row) => (
        <div className="flex flex-row justify-end items-center gap-1">
          {row.relationshipWith ? (
            <ActionIcon
              size="sm"
              onClick={() => handlePlusClick({ id: row.id })}
            >
              <Plus size={16} color="#1b6f8d" />
            </ActionIcon>
          ) : (
            <div className="w-8" />
          )}

          <ActionIcon size="sm" onClick={() => onViewClick(row.id)}>
            <Eye size={16} color="#1b6f8d" />
          </ActionIcon>

          <ActionIcon size="sm" onClick={() => handleSearchClick(row.id)}>
            <History size={16} color="#1b6f8d" />
          </ActionIcon>

          {(currentUser.loginAs.id === 3 || currentUser.loginAs.id === 4) && (
            <ActionIcon
              size="sm"
              onClick={() => {
                navigate("/app/agreements_manager/agreements/edit", {
                  state: { agreementId: row.id },
                });
              }}
            >
              <IconEdit size={16} color="#1b6f8d" />
            </ActionIcon>
          )}

          {currentUser.loginAs.id === 4 && (
            <ActionIcon
              size="sm"
              onClick={() => {
                setDeleteOpen(true);
                setDeleteId(row.id);
              }}
            >
              <IconTrash size={16} color="#1b6f8d" />
            </ActionIcon>
          )}
        </div>
      ),
    },
  ];

  return (
    <>
      <div className="flex flex-col">
        <div className="flex justify-between my-4">
          <Text>Contracts List</Text>
          {/* <Button
            color={themeColor(colors.agreement)}
            onClick={(e) => {
              e.stopPropagation();
              setOpen(true);
            }}
            style={{
              display:
                currentUser.loginAs.id === 3 || currentUser.loginAs.id === 4
                  ? "block"
                  : "none",
            }}
          >
            Create New Agreement
          </Button> */}
        </div>
      </div>
      <div className="flex w-full justify-between items-center">
        <div className="flex flex-col">
          <div className="flex flex-row-sm">
            {/* <Text size="xs" className="mb-2" color="gray">
              Case sensitive search
            </Text> */}
            <div className="flex items-center">
              {/* <TextInput
                value={listing.searchString}
                onChange={(input) => {
                  const val = getValueForInput(input);
                  setListing((prevState) => ({
                    ...prevState,
                    searchString: val,
                  }));
                }}
                placeholder="Type to search..."
                icon={<Search size={14} />}
              /> */}
              <Select
                className="mx-2"
                placeholder="Select Contract Status"
                value={listing.statusType}
                onChange={(val) => {
                  setListing((prevState) => ({
                    ...prevState,
                    statusType: val,
                  }));
                }}
                data={statusOptions}
                style={{ minWidth: "228px" }}
              />
              <Select
                className="mx-2"
                placeholder="Select Estamp"
                value={listing.estamp}
                onChange={(val) => {
                  setListing((prevState) => ({
                    ...prevState,
                    estamp: val,
                  }));
                }}
                data={estampOption}
                style={{ minWidth: "228px" }}
              />
              <Select
                className="mx-2"
                placeholder="Select Contract Type"
                value={listing.agreementType}
                onChange={(val) => {
                  setListing((prevState) => ({
                    ...prevState,
                    agreementType: val,
                  }));
                }}
                data={agreementTypeOptions}
                style={{ minWidth: "228px" }}
              />
              <Select
                className="mx-2"
                placeholder="Select Business Unit"
                value={listing.businessunit}
                data={transformedData}
                onChange={(value) => {
                  setListing((prevState) => ({
                    ...prevState,
                    businessunit: value,
                  }));
                }}
                style={{ minWidth: "228px" }}
              />
            </div>
          </div>
        </div>
      </div>
      <br />
      <div className="flex w-full justify-between items-center">
        <div className="flex flex-col">
          <div className="flex flex-row">
            <div className="flex items-center">
              {/* <Select
                className="mx-2"
                placeholder="Select location"
                searchable={true}
                value={listing.location}
                onChange={(val) => {
                  setListing((prevState) => ({
                    ...prevState,
                    location: val,
                  }));
                }}
                data={INDIA_STATES_UNIONS}
                style={{ minWidth: "228px" }}
              /> */}
              <TextInput
                className="mx-2"
                placeholder="Type Job Order"
                value={listing.jobOrder}
                onChange={(e) =>
                  setListing((preState) => ({
                    ...preState,
                    jobOrder: e.target.value,
                  }))
                }
                maw={400}
                mx="auto"
                style={{ minWidth: "228px" }}
              />
              <DatePicker
                className="mx-2"
                value={listing.startDate}
                onChange={(val) =>
                  setListing((preState) => ({ ...preState, startDate: val }))
                }
                placeholder="Created Date (From)"
                minDate={
                  new Date(new Date().setMonth(new Date().getMonth() - 3))
                }
                maw={400}
                mx="auto"
                style={{ minWidth: "228px" }}
              />
              <DatePicker
                className="mx-2"
                value={listing.endDate}
                onChange={(val) =>
                  setListing((preState) => ({ ...preState, endDate: val }))
                }
                placeholder="Created Date (To)"
                minDate={listing.startDate}
                disabled={listing.startDate ? false : true}
                style={{ minWidth: "228px" }}
              />
              <Select
                className="mx-2"
                value={listing.partyName}
                onChange={(value) => {
                  // const val = getValueForInput(input);
                  setListing((prevState) => ({
                    ...prevState,
                    partyName: value,
                  }));
                }}
                data={parties}
                searchable
                placeholder="Party Name"
                type="text"
                style={{ minWidth: "228px" }}
              />
              <br />
            </div>
          </div>
        </div>
      </div>
      <br />
      <Button
        className="mx-2"
        variant="outline"
        onClick={() => fetchAgreementsList({ page: 1 })}
      >
        Search
      </Button>
      <Button className="mx-2" onClick={clearHandler}>
        Clear
      </Button>
      <div className="flex float-right">
        <div className="flex">
          <Select
            value={listing.sortBy}
            onChange={(val) => handleKeyChange(val)}
            data={[
              { label: "Created Date", value: "createdAt" },
              { label: "End Date", value: "dueDateOfContract" },
              { label: "Type of Agreement", value: "typeOfAgreement" },
              { label: "Agreement Value", value: "agreementValue" },
              { label: "ID", value: "id" },
            ]}
          />
          <ActionIcon className="mx-2" onClick={toggleOrder}>
            {listing.sortDirection === "asc" ? (
              <SortAscending size={32} />
            ) : (
              <SortDescending size={32} />
            )}
          </ActionIcon>
        </div>
        <Button
          className="mx-2 btn btn-success btn-lg "
          disabled={exportButtonLoading}
          onClick={handleCsvDownload}
          style={{ backgroundColor: "#1b6f8d" }}
        >
          Export
        </Button>
      </div>
      {/* <Modal
        overflow="inside"
        closeOnClickOutside={false}
        size="calc(30vw)"
        opened={open}
        onClose={() => setOpen(!open)}
        title="Delete Agreement"
      ></Modal> */}
      {showModal && (
        <Modal
          overflow="inside"
          opened
          onClose={handleCloseModal} // Call the handler on modal close
          size="calc(80vw)"
        >
          <AgreementAuditLogModal agreementId={agreementId} />
        </Modal>
      )}
      {showModalRelated && (
        <Modal
          overflow="inside"
          opened
          onClose={handleCloseRelatedAgreementModal} // Call the handler on modal close
          size="calc(80vw)"
        >
          <RelatedAgreementModal agreementId={relatedAgreementId} />
        </Modal>
      )}

      <br />
      {uiConfigs.loading === loadingStates.LOADING && (
        <div className="flex flex-col">
          {Array.from({ length: 10 }).map((_, index) => (
            <Skeleton
              key={index}
              height={30}
              radius="md"
              className="my-1 w-full"
            />
          ))}
          <div className="flex flex-row justify-center">
            <Skeleton height={40} radius="md" className="w-40" />
          </div>
        </div>
      )}

      {listing.loaded &&
        uiConfigs.loading !== loadingStates.LOADING &&
        Boolean(data?.length) && (
          <div>
            <UniversalTable
              headers={tableHeaders}
              data={data?.filter((v) => v.agreementData?.json?.typeOfAgreement)}
              loading={uiConfigs.loading === loadingStates.LOADING}
              emptyMessage="No agreements found"
            />

            <TablePagination
              totalCount={listing.agreementsCount}
              page={uiConfigs.page}
              pageSize={pageSize}
              dataLength={data?.length || 0}
              onPageChange={(page) => setUiConfigs({ ...uiConfigs, page })}
              onPageSizeChange={(val) => setPageSize(val)}
            />
          </div>
        )}
      <Modal
        opened={open}
        onClose={() => setOpen(false)}
        size="calc(40vw)"
        style={{ marginTop: "12%" }}
        title="select contract Type"
      >
        <div className={Styles["popup-desig"]}>
          <p
            style={{
              cursor: "pointer",
              border: "2px solid lightblue",
              padding: "8px",
              margin: "0",
              marginBottom: "8px",
            }}
            onClick={() => navigate("/app/agreements_manager/agreements/new")}
          >
            Individual Agreement
          </p>
          <p
            style={{
              cursor: "pointer",
              border: "2px solid lightblue",
              padding: "8px",
              margin: "0",
            }}
            onClick={() =>
              navigate("/app/agreements_manager/agreements/new-bulk")
            }
          >
            Bulk Agreement
          </p>
          <div style={{ textAlign: "center", paddingTop: "3%" }}>
            <button
              style={{
                cursor: "pointer",
                background: "red",
                border: "none",
                padding: "8px",
                color: "white",
                margin: "5px 0",
                borderRadius: "10%",
              }}
              onClick={() => setOpen(false)}
            >
              Cancel
            </button>
          </div>
        </div>
      </Modal>
      <Modal
        opened={deleteOpen}
        onClose={() => {
          setDeleteOpen(false);
          setDeleteId(0);
        }}
        title="delete agreement"
      >
        <div className="my-2">
          <h4 className="mb-4 text-center">
            Are you sure you want to delete this agreement?
          </h4>
          <div className="flex flex-row justify-between">
            <Button
              style={{
                backgroundColor: colors.primary,
                borderRadius: "0.5rem",
                color: "#F5F5F5",
                // width: '180px',
              }}
              onClick={() => {
                setDeleteOpen(false);
                setDeleteId(0);
              }}
            >
              Cancel
            </Button>
            <Button
              // disabled={deleteLoading}
              className="ml-4"
              // style={{
              //   backgroundColor: deleteLoading ? "#ffcccc" : "#ff4d4d",
              //   borderRadius: "0.5rem",
              //   color: "#F5F5F5",
              //   // width: '180px',
              // }}
              onClick={() => deleteHandler()}
            >
              delete
              {/* {deleteLoading ? (
                <BeatLoader size={10} color={colors.rejected} />
              ) : (
                "Delete"
              )} */}
            </Button>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default AgreementsListPage;
